export default __webpack_public_path__ + "86cad5c5cac700d0fd013a0c36c3f8c5.png";